'use strict'

export default {
  // TODO: Add JS here
}



// WEBPACK FOOTER //
// ./src/components/PageNotFound/PageNotFound.js